function computePlaceholder({ searchMode, selectedKB }) {
  if (searchMode) {
    return 'Rechercher dans de précédentes conversations...';
  }
  if (!selectedKB) {
    return "Sélectionnez d'abord une base de connaissances";
  }
  return 'Posez votre question...';
}

export function ChatPromptInput({
  input,
  setInput,
  selectedKB,
  loading,
  hasSelectedModel,
  onSubmit,
  searchMode,
  onSearchQueryChange,
}) {
  const handleChange = (event) => {
    const value = event.target.value;
    setInput(value);
    if (searchMode) {
      onSearchQueryChange(value);
    }
  };

  const handleKeyDown = (event) => {
    if (event.key === 'Enter' && !event.shiftKey) {
      event.preventDefault();
      if (!searchMode) {
        onSubmit(event);
      }
    }
  };

  const disabled = searchMode ? false : !selectedKB || loading || !hasSelectedModel;

  return (
    <textarea
      data-testid="chat-input"
      value={input}
      onChange={handleChange}
      onKeyDown={handleKeyDown}
      placeholder={computePlaceholder({ searchMode, selectedKB })}
      disabled={disabled}
      className="h-32 w-full resize-none rounded-sm border border-zinc-800 bg-zinc-900/50 p-4 text-white placeholder:text-zinc-600 transition-colors duration-300 focus:border-white focus:outline-none focus:ring-0 disabled:cursor-not-allowed disabled:opacity-50"
      rows={5}
    />
  );
}
